<template>
  <eva-main @back="goBack">
    <template slot="nav">
      <div class="evaNav">
        <div class="itemWrap">
          <template v-for="(item, index) in nav">
            <div :key="index" :class="{evaItem: true, itemActive: idx === index}" @click="switchTab(index,item.path)">
              <p>{{item.text}}</p>
            </div>
          </template>
        </div>
        <!--<div v-if="showBtn" class="evaItem addItem" @click="addTemplate">添加模板</div>-->
      </div>
    </template>
    <template slot="main">
      <div class="evaMain">
        <router-view></router-view>
      </div>
    </template>
  </eva-main>
</template>

<script>
  export default {
    name: "Evaluation",
    data() {
      const nav = [
        {
          text: "培训班调查",
          path: "/system/eva/class",
        },
        {
          text: "讲师调查",
          path: "/system/eva/tea",
        },
        {
          text: "培训机构调查",
          path: "/system/eva/org",
        },
        {
          text: "模板设置",
          path: "/system/eva/tpl",
        },
      ];
      return {
        idx: 0,
        nav,
        // showBtn: false
      };
    },
    components: {
      "eva-main": () => import("@/components/LayOut/Common/up-down")
    },
    created() {
      this.setData();
    },
    methods: {
      setData() {
        const path = this.$route.path;
        this.nav.map((item, index) => {
          if(path.includes(item.path)) {
            this.idx = index;
          }
          /*if(path.includes("/tpl")) {
            this.showBtn = true;
          }*/
        });
      },
      goBack() {
        this.$router.push('/system/sm');
      },
      switchTab(idx, route) {
        if (idx == this.idx) return;
        // this.showBtn = route.includes("/tpl");
        this.idx = idx;
        this.$router.replace({path: route, query: {}});
      },
      /*addTemplate() {
        console.log("添加模板~");
      }*/
    }
  }
</script>

<style lang="stylus" scoped>
  @import '~@/assets/css/variable';
  .evaNav, .evaMain {
    flex: 1 1 auto;
    height: 100%;
  }

  .evaNav {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: $color_white;
    font-size: $font_size_big;
    line-height: $font_size_big;
    .itemWrap {
      display: flex;
    }
    .evaItem {
      height: 35px;
      padding: 0 10px;
      margin: 0 10px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
    }
    /*.itemActive,
    .addItem {
      background-color: $color_suc;
    }*/
    .itemActive {
      background-color: $color_suc;
    }
  }
  .evaMain {
    width: 100%;
    background-color: $block_bg_color_base;
  }
</style>
